/**
 * @generated SignedSource<<66253b36e3dd964813c9559bcb8deca4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultLayoutContainerPriceFormatterSupplierFragment$data = {
  readonly ecommerceSettings: {
    readonly currencyCode: string | null;
  } | null;
  readonly " $fragmentType": "defaultLayoutContainerPriceFormatterSupplierFragment";
};
export type defaultLayoutContainerPriceFormatterSupplierFragment$key = {
  readonly " $data"?: defaultLayoutContainerPriceFormatterSupplierFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultLayoutContainerPriceFormatterSupplierFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultLayoutContainerPriceFormatterSupplierFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9d47c7bd1a753fa141fded572546d0db";

export default node;
